import { Label } from "@aurumiq/ui/components/label";
import { Textarea } from "@aurumiq/ui/components/textarea";
import { useId } from "react";
import { SchemaForm } from "../schema-form/schema-form";
import { POST_FIELDS } from "./blocks";

/** Blog-post settings: the list excerpt plus `meta.post` (author, cover, tags, featured). */
export function PostPanel({
  excerpt,
  meta,
  onExcerpt,
  onMeta,
  metaIssues,
}: {
  excerpt: string;
  meta: Record<string, unknown>;
  onExcerpt: (e: string) => void;
  onMeta: (m: Record<string, unknown>) => void;
  metaIssues?: readonly { path: PropertyKey[]; message: string }[];
}) {
  const id = useId();
  const post = (meta.post ?? {}) as Record<string, unknown>;
  return (
    <div className="grid gap-4">
      <h2 className="font-semibold">Post</h2>
      <div>
        <Label htmlFor={`${id}-excerpt`}>Excerpt</Label>
        <Textarea
          id={`${id}-excerpt`}
          value={excerpt}
          maxLength={400}
          rows={3}
          onChange={(e) => onExcerpt(e.target.value)}
        />
        <p className="mt-1 text-muted-foreground text-xs">
          Shown on the blog index, in the RSS feed and as the default meta description.
        </p>
      </div>
      <SchemaForm
        fields={POST_FIELDS}
        value={post}
        onChange={(p) => onMeta({ ...meta, post: p })}
        issues={metaIssues}
        basePath={["post"]}
      />
    </div>
  );
}
